import instance from '@/api/api';
import router from "../router";

/**
 * get请求
 * @param params
 */
export let ajaxGet  = (url, params, successFn, failFn) =>{
    console.log(this);
    return;

    instance.get(url, params).then( res => {
        var ret = res.data;
        if(ret.code == 200){
            if (successFn) successFn(ret.data);
            return;
        }
        if (failFn) failFn(ret.message);
    });
};

/**
 * post请求
 * @param params
 */
const post = (url, params) => {

};

/**
 * 公共loading框
 * @param that
 * @param txt
 * @returns {*}
 */
export const showLoading = (that, txt) => {
    var loading = that.$loading({
        lock: true,
        text: txt || '正在加载...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0)'
    });

    return loading;
};

/**
 * 去答题
 * @param item
 */
export const toQestion = function (productCode) {
    router.push({path:'/testStart',query: {productCode:productCode}});
};

/**
 * 全局搜索
 * @param that 页面对象用于打开，错误提示
 * @param searchKey 关键字
 * @constructor
 */
export const woleSearch = function (searchKey, productType) {
    if (!searchKey || !searchKey.trim()) {
        return false;
    }
    router.push({path: "/WholeSearch", query: {searchKey: searchKey, productType}});
};
//查询分类接口
export const getProductClassifyInfo = () => {
  return instance.get('/common/getProductClassifyInfo');
}
//查询是否已有板块
export const getRuleMenuId = () => {
  return instance.post('/user/getRuleMenuId');
}
//会员选择板块接口
export const chooseRuleMenu = params => {
  return instance.post('/user/chooseRuleMenu?'+params);
}
//提供商收益信息查询
export const getUserIncome = () => {
  return instance.post('/user/getUserIncome');
}
//提现记录获取
export const getExtractRecord = params => {
  return instance.post('/user/findWithdraw',params);
}
//获取银行卡信息
export const getBankCardInfo = () => {
  return instance.post('/user/getBankInfo');
}
//申请提现
export const applyExtract = params =>{
  return instance.post('/user/withdraw',params);
}
//新增银行卡
export const addBankCard = params => {
  return instance.post('/user/bindBankInfo',params);
}
//删除银行卡
export const deleteBankCard = params =>{
  return instance.post('/user/delBankInfo?'+params);
}
//临时用户注册
export const tempUserRegist = params =>{
  return instance.post('/code/tempUserRegist?'+params);
}
//热门及免费产品查询
export const getHotProductInfo = params =>{
  return instance.get('/common/getHotProductInfo?'+params);
}
//生成产品二维码接口
export const generatorQrcode = params =>{
  return instance.post('/common/getProductQrCodeImage?'+ params);
}
//直接生成二维码
export const generatorQrcodeByText = params =>{
  return instance.post('/common/getQrcodeImage?' + params);
}
//获取二维码海报模板
export const getPostBackground = () =>{
  return instance.post('/common/getPosterList');
}



// WEBPACK FOOTER //
// ./src/api/common.js